import Model from 'flarum/common/Model';
export default class IPInfo extends Model {
  id() {
    return Model.attribute('id').call(this);
  }
  ip() {
    return Model.attribute('ip').call(this);
  }
  countryCode() {
    return Model.attribute('countryCode').call(this);
  }
  zipCode() {
    return Model.attribute('zipCode').call(this);
  }
  latitude() {
    return Model.attribute('latitude').call(this);
  }
  longitude() {
    return Model.attribute('longitude').call(this);
  }
  isp() {
    return Model.attribute('isp').call(this);
  }
  organization() {
    return Model.attribute('organization').call(this);
  }
  as() {
    return Model.attribute('as').call(this);
  }
  mobile() {
    return Model.attribute('mobile').call(this);
  }
  threatLevel() {
    return Model.attribute('threatLevel').call(this);
  }
  threatTypes() {
    const raw = Model.attribute('threatType').call(this);
    if (!raw) {
      return [];
    }
    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }
  error() {
    return Model.attribute('error').call(this);
  }
  dataProvider() {
    return Model.attribute('dataProvider').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  updatedAt() {
    return Model.attribute('updatedAt', Model.transformDate).call(this);
  }
}
flarum.reg.add('fof-geoip', 'common/model/IPInfo', IPInfo);